module Dashboard {
    export class SuccessfulExecutionsWidgetConfig implements IExecutionCountWidget {
        public id: string;
        public enabledByDefault: boolean;
        public displayName: string;
        public directiveName: string;
        public gridItemConfig: IGridItemConfig;
        public successWidget: boolean;
        public rangeInDays: number;
        public environments: string[];
        public displayPercentageOnTile: boolean;

        constructor(id: string) {
            this.id = id;
            this.enabledByDefault = true;
            this.displayName = FRENDS.Localizations.SuccessfulProcesses;
            this.directiveName = "frends-execution-count-widget";
            this.gridItemConfig = { col: 0, row: 0, sizeX: 3, sizeY: 2, disableResizing: true };
            this.successWidget = true;
            this.rangeInDays = 1;
            this.environments = [];
        }
    }

    export class FailedExecutionsWidgetConfig implements IExecutionCountWidget {
        public id: string;
        public enabledByDefault: boolean;
        public displayName: string;
        public directiveName: string;
        public gridItemConfig: IGridItemConfig;
        public successWidget: boolean;
        public rangeInDays: number;
        public environments: string[];
        public displayPercentageOnTile: boolean;

        constructor(id: string) {
            this.id = id;
            this.enabledByDefault = true;
            this.displayName = FRENDS.Localizations.FailedProcesses;
            this.directiveName = "frends-execution-count-widget";
            this.gridItemConfig = { col: 3, row: 0, sizeX: 3, sizeY: 2, disableResizing: true };
            this.successWidget = false;
            this.rangeInDays = 1;
            this.environments = [];
        }
    }

    export interface IExecutionCountWidget extends IWidgetConfig {
        successWidget: boolean;
        rangeInDays: number;
    }

    export interface IExecutionInfoForStatus {
        count: number;
        percentChange?: number;
    }
}